export default __webpack_public_path__ + "791128de20451c1cf2621e0addefa1e8.png";